module.exports = __webpack_public_path__ + "static/media/avatar_bluewhale.d2b8de79.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_bluewhale.png
// module id = 367
// module chunks = 0